import { styled } from 'styled-components'

export const Subtitle = styled.p`
	color: ${({ theme }) => theme.color.text};
	opacity: 0.6;
	margin-top: 36px;
	text-align: center;
`
